import * as React from "react";
import clsx from "clsx";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { getColorClass, getBackgroundColorClass } from "../colors/index.mjs";
const CountdownItem = (props) => {
  return /* @__PURE__ */ React.createElement("div", { className: "countdown__item", "aria-hidden": "true" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx(
        "countdown__item-inner",
        props.numberColor && "countdown__item-inner--custom-color ".concat(getColorClass(props.numberColor)),
        props.backgroundColor && "countdown__item-inner--custom-background ".concat(getBackgroundColorClass(props.backgroundColor))
      )
    },
    /* @__PURE__ */ React.createElement(TransitionGroup, { component: null }, /* @__PURE__ */ React.createElement(CSSTransition, { key: props.children, timeout: 1e3, classNames: "countdown__item-time--animate" }, /* @__PURE__ */ React.createElement("span", { className: "countdown__item-time h3" }, props.children)))
  ), /* @__PURE__ */ React.createElement("div", { className: "countdown__item-unit text-small text-bold" }, props.unit));
};
export {
  CountdownItem
};
